module.exports = __webpack_public_path__ + "static/img/btn_bg.bd93cb6b.png";